import axios from 'axios';
const API_URL = '/api/dept';

export const getDepts = () => axios.get(API_URL);
export const getDept = (code) => axios.get(`${API_URL}/${code}`);
export const createDept = (data) => axios.post(API_URL, data);
export const updateDept = (code, data) => axios.put(`${API_URL}/${code}`, data);
export const deleteDept = (code) => axios.delete(`${API_URL}/${code}`);
export const refreshDeptHierarchy = () => axios.post(`${API_URL}/refresh`);
